import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarLink',
  props: {
    name: {},
    to: {},
    isDropdown: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: _normalizeClass(["nav-link", {'dropdown-item': __props.isDropdown}]),
    to: `/${__props.to ?? __props.name.toLowerCase()}`,
    "active-class": "custom-active"
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.name), 1)
    ]),
    _: 1
  }, 8, ["class", "to"]))
}
}

})